import { Button, Chip, Divider, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material'
import React from 'react'
import GroupsIcon from '@mui/icons-material/Groups';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import { LeyendaRecolectores } from './LeyendaRecolectores';

export const CuadrillaCard = ({ info }) => {

    const getColor = (info) => {
        if (info.comprobado === 0) {
            return 'primary';
        }
        if (info.comprobado === 1 && info.respuesta_comprobacion === 1) {
            return 'secondary';
        }
        if (info.comprobado === 1 && info.respuesta_comprobacion === 0) {
            return 'error';
        }
    }

    return (
        <Grid
            container
            direction="row"
            justifyContent="start"
            alignItems="center"
            size={{ xs: 12 }}
            sx={{
                p: 2,
                mb: 2,
            }}
        >

            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="start"
                size={{ xs: 12 }}
            >
                <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignItems="start"
                    size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                    gap={1}
                >
                    <Grid
                        container
                        direction="row"
                        justifyContent="start"
                        alignItems="start"
                        size={{ xs: 12 }}
                    >
                        <GroupWorkIcon sx={{ fontSize: 30 }} color='warning' />
                        <Typography variant='h5'>
                            &nbsp;Grupo N: {info.datos_cuadrilla.id_cuadrilla}
                        </Typography>
                    </Grid>

                    <Typography variant='h6'>
                        <EventIcon sx={{ mb: -1, fontSize: 30 }} color='primary' /> {info.datos_cuadrilla.fecha_cuadrilla}
                    </Typography>

                    <Typography variant='subtitle1'>
                        <AssignmentIndIcon sx={{ mb: -1, fontSize: 30 }} color='secondary' /> Cabo: {info.datos_cuadrilla.nombre_cabo} {info.datos_cuadrilla.apellidos_cabo}
                    </Typography>

                    <Typography variant='subtitle1'>
                        <GroupsIcon sx={{ mb: -1, fontSize: 30 }} color='black' /> Recolectores: {
                            info.recolectores.no_comprobados.length + info.recolectores.comprobados.length + info.recolectores.error_comprobacion.length
                        }
                    </Typography>
                </Grid>

                <Grid
                    container
                    direction="column"
                    justifyContent="start"
                    alignItems={{ xs: "start", md: 'end' }}
                    size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                    gap={1}
                >
                    <Grid item size={{ xs: 8, md: 6, lg: 1.5 }}>
                        <FormControl variant="standard" fullWidth size='small'>
                            <InputLabel id="demo-simple-select-standard-label">Validado</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                // value={info.datos_cuadrilla.validado}
                                // onChange={handleChange}
                                label="Validado"
                                defaultValue={info.datos_cuadrilla.validado}
                            >
                                <MenuItem value={0}>No</MenuItem>
                                <MenuItem value={1}>Si</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item size={{ xs: 8, md: 6, lg: 1.5 }}>
                        <FormControl variant="standard" fullWidth size='small'>
                            <InputLabel id="demo-simple-select-standard-label">Revisado</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                // value={age}
                                // onChange={handleChange}
                                label="Revisado"
                                defaultValue={info.datos_cuadrilla.revisado}
                            >
                                <MenuItem value={0}>No</MenuItem>
                                <MenuItem value={1}>Si</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item size={{ xs: 8, md: 6, lg: 1.5 }}>
                        <Button variant='contained' fullWidth>
                            actualizar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>


            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="start"
                size={{ xs: 12 }}
                sx={{ mt: 2 }}
            >

                <Grid
                    container
                    direction="row"
                    justifyContent="start"
                    alignItems="start"
                    size={{ xs: 12 }}
                    sx={{ display: info.recolectores.no_comprobados.length === 0 ? 'none' : 'flex' }}
                >
                    <Typography variant='subtitle2'>
                        No comprobados ({info.recolectores.no_comprobados.length}):
                    </Typography>

                    <Divider />
                    {info.recolectores.no_comprobados.map((info, index) => (
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="end"
                            size={{ xs: 12, sm: 12, md: 6, lg: 3 }}
                            sx={{ py: 1.5 }}
                        >
                            <Typography variant='body1'>
                                <PersonIcon sx={{ mb: -0.7, fontSize: 28 }} color={getColor(info)} />&nbsp;

                                {info.nombre_recolector} {info.apellidos_recolector} - {info.nif_recolector}&nbsp;
                            </Typography>

                            <Chip
                                icon={<SensorOccupiedIcon />}
                                label={
                                    !info.puntuacion_comprobacion
                                        ? "0.0/10.0"
                                        : <> {info.puntuacion_comprobacion}/10.0</>
                                }
                                size="small"
                                color={getColor(info)}
                            />

                        </Grid>
                    ))}
                </Grid>


                <Grid
                    container
                    direction="row"
                    justifyContent="start"
                    alignItems="start"
                    size={{ xs: 12 }}
                    sx={{ display: info.recolectores.comprobados.length === 0 ? 'none' : 'flex' }}
                >
                    <Typography variant='subtitle2'>
                        Comprobados ({info.recolectores.comprobados.length}):
                    </Typography>

                    <Divider />
                    {info.recolectores.comprobados.map((info, index) => (
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="end"
                            size={{ xs: 12, sm: 12, md: 6, lg: 3 }}
                            sx={{ py: 1.5 }}
                        >
                            <Typography variant='body1'>
                                <PersonIcon sx={{ mb: -0.7, fontSize: 28 }} color={getColor(info)} />&nbsp;

                                {info.nombre_recolector} {info.apellidos_recolector} - {info.nif_recolector}&nbsp;
                            </Typography>

                            <Chip
                                icon={<SensorOccupiedIcon />}
                                label={
                                    !info.puntuacion_comprobacion
                                        ? "0.0/10.0"
                                        : <> {info.puntuacion_comprobacion}/10.0</>
                                }
                                size="small"
                                color={getColor(info)}
                            />

                        </Grid>
                    ))}

                </Grid>


                <Grid
                    container
                    direction="row"
                    justifyContent="start"
                    alignItems="start"
                    size={{ xs: 12 }}
                    sx={{ display: info.recolectores.error_comprobacion.length === 0 ? 'none' : 'flex' }}
                >
                    <Typography variant='subtitle2'>
                        Error en la comprobación ({info.recolectores.error_comprobacion.length}):
                    </Typography>

                    <Divider />
                    {info.recolectores.error_comprobacion.map((info, index) => (
                        <Grid
                            container
                            direction="row"
                            justifyContent="start"
                            alignItems="end"
                            size={{ xs: 12, sm: 12, md: 6, lg: 3 }}
                            sx={{ py: 1.5 }}
                        >
                            <Typography variant='body1' color={getColor(info)} sx={{ fontWeight: 600 }}>
                                <PersonIcon sx={{ mb: -0.7, fontSize: 28 }} color={getColor(info)} />&nbsp;

                                {info.nombre_recolector} {info.apellidos_recolector} - {info.nif_recolector}&nbsp;
                            </Typography>

                            <Chip
                                icon={<SensorOccupiedIcon />}
                                label={
                                    !info.puntuacion_comprobacion
                                        ? "0.0/10.0"
                                        : <> {info.puntuacion_comprobacion}/10.0</>
                                }
                                size="small"
                                color={getColor(info)}
                            />

                        </Grid>
                    ))}
                </Grid>



            </Grid>

            <Divider />


            <Grid
                container
                direction="row"
                justifyContent="start"
                alignItems="end"
                size={{ xs: 12}}
                sx={{ minHeight: '10vh'}}
            >
                <LeyendaRecolectores />
            </Grid>
        </Grid>
    )
}
